module.exports = __webpack_public_path__ + "img/blueLogo.cbeeca09.png";